<template>
	<el-row class="sense-container">
		<div class="sense-header">
			<div class="sense-header-box clearfix">
				<h1 class="fl">消息通知</h1>
				<div class="sense-nav fl">
					<el-menu					    
					    class="el-menu-demo"
					    mode="horizontal"					 
					    background-color="#001529">
					    <el-menu-item index="1">
					    	<router-link tag="span" to="/allMessage" class="tag-list">全部消息</router-link>					    	
					    </el-menu-item>
						<el-menu-item index="2">
							<router-link tag="span" to="/unreadMessage" class="tag-list">未读消息</router-link>	
						</el-menu-item>
						<el-menu-item index="3">
							<router-link tag="span" to="/readedMessage" class="tag-list">已读消息</router-link>	
						</el-menu-item>
						<el-menu-item index="4">
							<router-link tag="span" to="/balanceWarn" class="tag-list">余额提醒</router-link>	
						</el-menu-item>
					</el-menu>
				</div>
			</div>
		</div>
		<div class="sense-content">			
			<transition name="fade" mode="out-in">
				<router-view></router-view>
			</transition>
		</div>
		<div class="sense-footer">
			北京深盾科技股份有限公司 &copy;
			<a target="_blank" href="http://www.beian.miit.gov.cn">京ICP备16009104号</a>
			<a target="_blank" href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=11010802025663">
				<img src="../../static/img/keep-record.png">京公网安备 11010802025663号</em>
			</a>
		</div>
	</el-row>
</template>

<script>
	import { ajax } from '../api/api.js'
	
	export default {
		data() {
			return {
							
			}
		},
		methods: {
			
		},
		mounted() {
		
		}
	}

</script>

<style lang="scss">

	$common-color: #409EFF;
	
</style>


// WEBPACK FOOTER //
// Home.vue?0999a0f1